<template>
    <veui-dialog
        :open="isShow"
        :footless="true"
        :outside-closable="false"
        ui="auto"
        :title="'百度法律平台功能升级通知'"
        overlay-class="agent-dialog-new"
        @cancel="clickCloseBtn"
    >
        <div
            v-visually="{
                serverId: 19842,
                area: 'agent-create-dialog-new',
                isNotRepeat: true,
            }"
            class="content"
        >
            <div class="sub-content">
                律师信息的流量曝光、线索收集将逐步切换至律师智能体形式，未创建智能体的律师用户在<span class="red">2025年12月31日</span>后可能无法继续使用本平台的全部业务功能。
            </div>
            <div class="main-content">
                <div style="font-weight: 500;">尊敬的律师：</div>
                <p>感谢您长期以来对本平台的信任与支持。为了进一步增强律师的线上服务能力，提升平台用户体验，本平台将自即日起进行功能迭代升级，
                    入驻律师用户权益及信息展示方式将分批次进行调整，具体调整内容如下：</p>
                <p>律师信息的分发、展示将逐步切换至律师智能体形式，律师智能体作为平台提供的标准化工具，用于辅助律师实现客户触达、咨询对接及服务推广。
                    入驻并通过认证的律师用户，须完成个人律师智能体的创建，方可继续正常使用本平台提供的各项功能与服务。为减少对您权益的影响，自本通知至
                    <span class="red">2025年12月31日</span>的过渡期内，您仍可正常使用本平台的业务功能，如果您是会员用户，则在会员到期前您仍可使用会员权益。
                    但未创建智能体的律师用户在过渡期后或会员到期后可能无法继续使用本平台的全部业务功能，包括但不限于：案件管理、客户沟通、信息发布、资源获取等。</p>
                <p>点击确认后将完成律师智能体的创建，确认即同意<a href="https://lvlin-fe-saas.cdn.bcebos.com/agent-rule.pdf" target="_blank">《法行宝律师智能体入驻服务协议》</a></p>
            </div>
        </div>
        <div class="foot">
            <div
                class="confirm-btn"
                @click="clickOpenBtn"
            >
                <div class="text">确认并同意协议</div>
            </div>
        </div>
    </veui-dialog>
</template>

<script>
import {Dialog} from 'veui';
import {mapActions} from 'vuex';
export default {
    components: {
        'veui-dialog': Dialog
    },
    data() {
        return {
            isSubmitting: false,
            isShow: true
        };
    },
    methods: {
        ...mapActions({
            getAgentData: 'lawStore/getAgentData'
        }),
        // 点击开启智能体按钮
        clickOpenBtn() {
            if (this.isSubmitting) {
                return;
            }
            this.isSubmitting = true;
            this.$wywLog.send({
                serverId: 19842,
                area: 'agent-create-dialog-new-confirm',
                action: 'click'
            });
            // 请求接口
            this.$http.post('/bp/api/lawyeragent/createbyuid')
                .then(res => {
                    if (res && +res.code === 0) {
                        this.$toast.success('已完成协议更新确认，并同步为您创建智能体');
                        // 刷新智能体信息
                        this.getAgentData();
                        this.isShow = false;
                        return;
                    }
                    if (res && +res.code === 12009) {
                        this.$toast.error(res && res.msg || '律师智能体已存在');
                        // 刷新智能体信息
                        this.getAgentData();
                        this.isShow = false;
                        return;
                    }
                    this.$toast.error(res && res.msg || '提交失败，请稍后再试～');
                })
                .catch(() => {
                    this.$toast.error('提交失败，请稍后再试～');
                })
                .finally(() => {
                    this.isSubmitting = false;
                    this.isShow = false;
                });
        },
        // 关闭弹窗
        clickCloseBtn() {
            this.isShow = false;
            this.$wywLog.send({
                serverId: 19842,
                area: 'agent-create-dialog-new-close',
                action: 'click'
            });
        }
    },
    watch: {
        isShow(val) {
            if (!val) {
                // 弹窗关闭后抛出变量，让其他弹窗无法打开
                this.$emit('close');
            }
        }
    }
};
</script>

<style lang="less" scoped>
.agent-dialog-new {
    /deep/.veui-dialog-content {
        border-radius: 8px;
        width: 640px;
        box-shadow: 0 0 10px 0 #c4c4c480;
        background-color: #fff;
        padding: 0 0 24px 0;

        .veui-dialog-content-head {
            display: block;
            position: relative;

            .veui-dialog-content-head-title {
                display: block;
                text-align: center;
            }

            .veui-dialog-content-head-close {
                position: absolute;
                right: 24px;
                top: 24px;
                color: #adadad;
            }
        }

        .veui-dialog-content-body {
            margin: 0;
            display: flex;
            flex-direction: column;
            align-items: center;

            .content {
                border-radius: 6px;

                .red {
                    color: #ff4262;
                }

                .sub-content {
                    font-weight: 400;
                    font-size: 15px;
                    line-height: 1.6;
                }

                .main-content {
                    background: #f5f5f5;
                    border-radius: 8px;
                    padding: 15px 17px;
                    margin-top: 12px;
                    color: #000;
                    line-height: 1.5;

                    p {
                        text-indent: 2em;
                    }
                }
            }

            .foot {
                margin-top: 24px;
                display: flex;
                flex-direction: column;
                align-items: center;

                .confirm-btn {
                    width: 190px;
                    height: 36px;
                    border-radius: 4px;
                    background-color: #05f;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;

                    .text {
                        font-family: PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 19.6px;
                        letter-spacing: 0;
                        text-align: center;
                        color: #fff;
                    }
                }

                .confirm-btn:hover {
                    background-color: #06f;
                }
            }
        }
    }
}
</style>